const notificationActionTypes = {
  NOTIFICATION_SET_DATA: 'NOTIFICATION_SET_DATA',
  NOTIFICATION_SHOW: 'NOTIFICATION_SHOW',
  NOTIFICATION_DELETE: 'NOTIFICATION_DELETE',
  NOTIFICATION_CLEAR_ALL: 'NOTIFICATION_CLEAR_ALL',
};

export default notificationActionTypes;
